module.exports = __webpack_public_path__ + "static/media/i4c-mission.3f189eac.svg";